var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTranslateLeft = function SvgTranslateLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 41,
    height: 28,
    viewBox: "0 0 93.05 62.95",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73 37a5.679 5.679 0 0 1-2.57-4.38c-.62-2.6.55-4.99 4.1-7.4 6.79-4.62 14.4-12.8 19.37-18.13 2.84-3.06 4.94-5.32 6.43-6.24a5.699 5.699 0 0 1 7.84 1.86c1.65 2.67.82 6.19-1.85 7.84-.12.07-1.79 1.87-4.07 4.32-3.12 3.36-7.24 7.78-11.74 11.96l4.02-.09c8.07-.2 16.68-.41 22.92.24 8.14.84 13.17.47 18.41.09 5.54-.4 11.3-.83 20.79-.06l1.16.05c3.15.11 5.61 2.76 5.5 5.9a5.701 5.701 0 0 1-5.9 5.5l-1.65-.05c-8.69-.7-14-.32-19.09.06-5.71.42-11.18.82-20.38-.14-5.63-.58-13.82-.38-21.49-.2l-1.94.05c2.94 2.73 7.23 6.39 11.04 9.63l6.01 5.14c2.37 2.08 2.6 5.7.51 8.06a5.712 5.712 0 0 1-8.06.52c-2.5-2.2-4.17-3.63-5.84-5.05-5.21-4.44-11.31-9.63-14.07-12.51-1.65-1.72-3.82-3.07-5.54-4.14-1.53-.95-2.84-1.76-3.91-2.83z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgTranslateLeft;